import { render, staticRenderFns } from "./RegisterSupplier.vue?vue&type=template&id=1ae0f69f&"
import script from "./RegisterSupplier.vue?vue&type=script&lang=js&"
export * from "./RegisterSupplier.vue?vue&type=script&lang=js&"
import style0 from "./RegisterSupplier.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports